import React, { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useToken } from "../common/hooks/use-token";

interface PrivateRouteProps {
  children: JSX.Element;
}

export default function PrivateRoute({ children }: PrivateRouteProps): JSX.Element {
  const [token] = useToken();
  const isAuthenticated = !!token;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}